/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type withWidgetData_reports = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "withWidgetData_reports",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "WidgetMenu_reports",
      "args": null
    }
  ],
  "type": "ReportConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/withWidgetData/__generated__/withWidgetData_reports.graphql.js